import { ButtonLink } from '#ui/ButtonLink.tsx'
import { HeaderRoot } from '#ui/HeaderRoot.tsx'

export function HeaderPlaceholder() {
  return (
    <HeaderRoot>
      <div className='flex gap-4 space-y-4 sm:space-y-0'>
        <ButtonLink to='/join'>Sign up</ButtonLink>
        <ButtonLink to='/login'>Log In</ButtonLink>
      </div>
    </HeaderRoot>
  )
}
